<template>
  <v-menu>
    <template #activator="{ on, attrs }">
      <v-icon
        v-bind="attrs"
        v-on="on"
        size="16"
        color="grey"
        class="mr-1"
        v-text="icons.locale"
      /><span
        v-bind="attrs"
        v-on="on"
        class="text-body-2 grey--text text--lighten-1"
        v-text="currentLocale.toUpperCase()"
      />
    </template>
    <v-list
      dense
      rounded
      color="secondary"
    >
      <v-list-item-group
        v-model="currentLocale"
        mandatory
      >
        <v-list-item
          v-for="locale in locales"
          :key="locale.value"
          :value="locale.value"
        >
          <v-list-item-content>
            <v-list-item-title v-text="locale.text" />
          </v-list-item-content>
        </v-list-item>
      </v-list-item-group>
    </v-list>
  </v-menu>
</template>

<script>
  import ChangesLocale from '@/Mixins/ChangesLocale'
  import UsesIcons from '@/Mixins/UsesIcons'

  export default {
    mixins: [
      ChangesLocale,
      UsesIcons,
    ],

    computed: {
      currentLocale: {
        get () {
          return this.$store.state.locale
        },
        set (v) {
          this.changeLocale(v)
        },
      },
    },
}
</script>
